module.exports = __webpack_public_path__ + "static/media/ionicon.c4c555db.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/ionicon/ionicon.svg?phty4a
 ** module id = 178
 ** module chunks = 0
 **/